import Setting from "features/settings/containers/Setting";
import React from "react";

const SettingComponent = () => {
  return <Setting />;
};

export default SettingComponent;
